import React from 'react';
import Skeleton from '../Skeleton';
import './AllSubmissionsSkeleton.css';

const AllSubmissionsSkeleton = () => {
  return (
    <div className="all-submissions-skeleton">
      {/* Page Header - Exact match with AllSubmissions */}
      <div className="page-header" style={{ marginBottom: '24px' }}>
        <div>
          <Skeleton variant="text" width="180px" height={32} style={{ marginBottom: '8px' }} />
          <Skeleton variant="text" width="380px" height={18} />
        </div>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Skeleton variant="button" width="150px" height={40} style={{ borderRadius: '8px' }} />
          <Skeleton variant="button" width="130px" height={40} style={{ borderRadius: '8px' }} />
          <Skeleton variant="button" width="180px" height={40} style={{ borderRadius: '8px' }} />
        </div>
      </div>

      {/* Filters Section - Exact match */}
      <div className="filters-section" style={{ marginBottom: '24px' }}>
        <div className="filter-row">
          <Skeleton variant="rect" width="100%" height={42} style={{ borderRadius: '6px', maxWidth: '300px' }} />
          <Skeleton variant="rect" width="160px" height={42} style={{ borderRadius: '6px' }} />
          <Skeleton variant="rect" width="160px" height={42} style={{ borderRadius: '6px' }} />
          <Skeleton variant="rect" width="200px" height={42} style={{ borderRadius: '6px' }} />
          <Skeleton variant="button" width="120px" height={42} style={{ borderRadius: '6px' }} />
          <Skeleton variant="button" width="80px" height={42} style={{ borderRadius: '6px' }} />
        </div>
      </div>

      {/* DataTable - Exact match with proper table structure */}
      <div className="data-table-container">
        {/* Table Header */}
        <div className="table-header">
          <div className="table-title-section">
            <h2 className="table-title">
              <Skeleton variant="text" width="180px" height={15} />
            </h2>
          </div>
        </div>

        {/* Table Wrapper */}
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                {/* Checkbox column */}
                <th style={{ padding: '8px 14px', width: '40px' }}>
                  <Skeleton variant="rect" width="18px" height={18} style={{ borderRadius: '3px' }} />
                </th>
                {/* Row number column */}
                <th style={{ padding: '8px 14px', width: '50px' }}>
                  <Skeleton variant="text" width="15px" height={11} />
                </th>
                {/* Date column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="40px" height={11} />
                </th>
                {/* Worker Name column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="95px" height={11} />
                </th>
                {/* Job Site column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="65px" height={11} />
                </th>
                {/* Hours column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="50px" height={11} />
                </th>
                {/* Comments column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="75px" height={11} />
                </th>
                {/* Form Type column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="80px" height={11} />
                </th>
                {/* Files column */}
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="45px" height={11} />
                </th>
                {/* Actions column */}
                <th style={{ padding: '8px 14px', textAlign: 'right' }}>
                  <Skeleton variant="text" width="65px" height={11} style={{ marginLeft: 'auto' }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                <tr key={row}>
                  {/* Checkbox */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="rect" width="18px" height={18} style={{ borderRadius: '3px' }} />
                  </td>
                  {/* Row number */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="20px" height={13} />
                  </td>
                  {/* Date */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="85px" height={13} />
                  </td>
                  {/* Worker Name */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="120px" height={13} />
                  </td>
                  {/* Job Site */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="100px" height={13} />
                  </td>
                  {/* Hours */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="35px" height={13} />
                  </td>
                  {/* Comments */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="180px" height={13} />
                  </td>
                  {/* Form Type Badge */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="badge" width="110px" height={24} />
                  </td>
                  {/* Files */}
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="30px" height={13} />
                  </td>
                  {/* Actions */}
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <Skeleton variant="button" width="65px" height={28} />
                      <Skeleton variant="button" width="70px" height={28} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="table-pagination">
          <div className="pagination-info">
            <Skeleton variant="text" width="180px" height={13} />
          </div>
          <div className="pagination-controls">
            <Skeleton variant="button" width="85px" height={36} style={{ borderRadius: '4px' }} />
            <Skeleton variant="button" width="36px" height={36} style={{ borderRadius: '4px' }} />
            <Skeleton variant="button" width="36px" height={36} style={{ borderRadius: '4px' }} />
            <Skeleton variant="button" width="36px" height={36} style={{ borderRadius: '4px' }} />
            <Skeleton variant="button" width="85px" height={36} style={{ borderRadius: '4px' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllSubmissionsSkeleton;
